import React from "react";
import styled from "styled-components";

const LoadingContainer = styled.div`
  margin: 40px;
`;

export const LoadingPage = () => {
  return <LoadingContainer>Loading...</LoadingContainer>;
};
